import { memo } from 'react';
import { Marker, useMap } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import useSupercluster from 'use-supercluster';
import { useMapActions } from '../../../../hooks/useMapActions';
import { useStyles } from '../../../../hooks/useStyles';
import { mapUserGeoJsonState, mapViewState } from '../../../../storage/map';
import UserMarker from './UserMarker';

function UsersClusters() {
  const { map } = useMap();
  const { css, theme } = useStyles();
  const { zoomTo } = useMapActions();
  const viewState = useRecoilValue(mapViewState);
  const usersGeojson = useRecoilValue(mapUserGeoJsonState);
  const mapBounds = map?.getBounds();
  const bounds = mapBounds ? (mapBounds.toArray().flat() as [number, number, number, number]) : undefined;

  const { clusters } = useSupercluster({
    points: usersGeojson,
    bounds: bounds,
    zoom: viewState.zoom,
    options: { radius: 50, maxZoom: 19 },
  });

  return (
    <>
      {clusters.map((cluster) => {
        const [lng, lat] = cluster.geometry.coordinates;
        const { cluster: isCluster, point_count: pointCount, id } = cluster.properties;

        if (isCluster) {
          return (
            <Marker
              key={`cluster-${cluster.id}`}
              latitude={lat}
              longitude={lng}
              onClick={() => zoomTo({ lat, lng }, viewState.zoom + 3 < 12 ? viewState.zoom + 3 : 12)}
            >
              <div
                className={css({
                  ...theme.typography.LabelSmall,
                  backgroundImage: "url('/img/icons/map/cluster.png')",
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '50px',
                  height: '50px',
                  fontWeight: '700',
                })}
              >
                {pointCount}
              </div>
            </Marker>
          );
        }

        if (id) {
          return (
            <UserMarker
              key={id}
              userId={id}
            />
          );
        }
        return null;
      })}
    </>
  );
}

export default memo(UsersClusters);
